import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import {
  ReferralDetail,
} from "../../../models/Referral";
import { formatDate } from "../../../utils/DateTime";
import { DateFormats } from "../../../constants/Date";
import fontWeight from "../../../styles/mui/fontWeight";
import colors from "../../../styles/colors/colors";
import { ApplicationTitles, Header, PatientListHeaderLabel } from "../../../constants/HomePage";
import { TableCellRow } from "../style/style";
import { UserPageTrack } from "../../../models/User";

import { getCurrnetPageFullPath, getUaserPageViewPayload } from "../../../utils";
import { getValidMessageType } from "../../../constants/User";
import { redirectUri } from "../../../constants/Config";

export interface PropsFromState {
  referralData: ReferralDetail[];
}

export interface PropsFromDispatch {
  postUserPageTrack: (payload: UserPageTrack) => void;
}

type AllProps = PropsFromState & PropsFromDispatch;

const PatientList: React.FC<AllProps> = ({
  referralData,
  postUserPageTrack
}) => {
  const [groupedItems, setGroupedItems] = useState<any>([])
  const sortedItems = [...referralData].sort((a, b) =>
    a.lastName.localeCompare(b.lastName)
  );
  
  const groupItemsByAlphabet = (items: ReferralDetail[]) => {
    return items.reduce((groups: any, item: ReferralDetail) => {
      const firstLetter = item.lastName.charAt(0).toUpperCase();
      if (!groups[firstLetter]) {
        groups[firstLetter] = [];
      }
      groups[firstLetter].push(item);
      return groups;
    }, {});
  };
  useEffect(() => {
    setGroupedItems(groupItemsByAlphabet(sortedItems));
  }, [referralData])
  
  useEffect(() => {
    postUserPageTrack(
      getUaserPageViewPayload(
        getValidMessageType(ApplicationTitles.PATIENT_LIST),
        getCurrnetPageFullPath(),
        redirectUri,
        ""
      )
    );
  }, []);

  const rowCell = (value: string | number, index: number, isTotal?: boolean) => {
    return <TableCell style={TableCellRow(index, isTotal)}>{value}</TableCell>;
  };
  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {PatientListHeaderLabel.map((data: Header) => (
                <TableCell key={data.label}>
                  <Box sx={data.style?.cell}>
                    <Typography
                      color={colors.portalColor[2]}
                      variant="h4"
                      fontWeight={fontWeight[6]}
                    >
                      {data.label}
                    </Typography>
                  </Box>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(groupedItems).map((letter) => (
              <React.Fragment key={letter}>
                <TableRow>
                  <Grid size={{ xs: 12 }}>
                    <TableCell align="left" style={{ borderBottom: 0 }}>
                      <Typography
                        variant="h3"
                        fontWeight={fontWeight[6]}
                        color={colors.black[1]}
                      >
                        {letter}
                      </Typography>
                    </TableCell>
                  </Grid>
                </TableRow>
                {groupedItems[letter].map((item: ReferralDetail, index: number) => (
                  <TableRow key={item.authorizationNumber}>
                    {rowCell(item.lastName + ", " + item.firstName, index)}
                    {rowCell(
                      formatDate(item.dateOfBirth, DateFormats.MM_DD_YYYY),
                      index
                    )}
                    {rowCell(item.authorizationNumber, index)}
                    {rowCell(
                      formatDate(
                        item.minEffectiveFromDate,
                        DateFormats.MM_DD_YYYY
                      ) +
                        "  -  " +
                        formatDate(
                          item.maxEffectiveThroughDate,
                          DateFormats.MM_DD_YYYY
                        ),
                      index
                    )}
                    {rowCell(item.sn, index)}
                    {rowCell(item.pt, index)}
                    {rowCell(item.ot, index)}
                    {rowCell(item.st, index)}
                    {rowCell(item.msw, index)}
                    {rowCell(item.hha, index)}
                    {rowCell(
                      Number(
                        item.sn +
                          item.pt +
                          item.ot +
                          item.st +
                          item.msw +
                          item.hha
                      ),
                      index,
                      true
                    )}
                  </TableRow>
                ))}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
export default PatientList;
